<template lang="pug">
  .body.operator-table.body-flex.bigger-first-col
    .table-choose-panel.body-flex
      .toolbar-table.toolbar.toolbar_no-padding.toolbar_margin-bottom
        .toolbar__line.line.line_full-width.line_space-between
          .select.select_no-border.semibold Обслуживание объекта
          .toolbar.toolbar--modal.toolbar_no-padding
            .line.toolbar__line
              .actions-panel
                e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="addNewRowToTable()" label="Добавить" )

      e-table-editable(
        ref="operator"
        :attributes="operatorAttr"
        :dataUrl="operatorDataUrl"
        :postUrl="operatorPostUrl"
        :patchUrl="operatorPatchUrl"
        :deleteUrl="operatorDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :afterFetchData="afterFetchData"
        :afterValidate="afterValidate"
        :tableInOnlineMode="tableInOnlineMode"
      )
</template>

<script>
import { garbage, core, tko } from '@/api/api-endpoints'
import { garbageOffline } from '@/api/api-offline-endpoints'
import operatorTableMixin from './mixins/operator-table-mixin'

export default {
  name: 'operator-table',
  mixins: [operatorTableMixin],
  props: {
    tabView: null,
    id: null,
  },
  computed: {
    operatorDataUrl() {
      if (this.id) {
        let routeQuery = { query: {} }

        return garbage.services(routeQuery, this.id)
      }

      // if new record, offline save
      return garbageOffline.operatorTable(this.$route.name)
    },
  },
  methods: {
    suggestionEndpointObject(ctx, q) {
      return tko.objects({ query: { q: q, 'per-page': 50 } })
    },
    suggestionEndpointOperatorTransport() {
      return core.statuses({ fields: 'tko_operator_transport' })
    },
    suggestionEndpointOperatorService() {
      return core.statuses({ fields: 'tko_operator' })
    },
    suggestionEndpointGarbageGroup() {
      return core.statuses({ fields: 'garbage_group' })
    },
    operatorPostUrl() {
      return garbage.servicePost(this.id)
    },
    operatorPatchUrl(context, model) {
      return garbage.servicePatch(model.id)
    },
    operatorDeleteUrl(context, model) {
      return garbage.serviceDelete(model.id)
    },
  },
}
</script>
